<template>
  <ion-page>
    <ion-menu
      side="start"
      menu-id="appMenu"
      content-id="mainApp"
      class="menu-app"
    >
      <ion-header>
        <ion-toolbar>
          <div class="ion-padding-top">
            <ion-row>
              <ion-col size="12" class="center">
                <ion-thumbnail>
                  <img class="" src="/img/icons/android-chrome-192x192.png" />
                </ion-thumbnail>
              </ion-col>
            </ion-row>
          </div>
        </ion-toolbar>
        <div class="menu-app-header-separator">
          <ion-grid class="center">
            <ion-row>
              <ion-col>
                <a
                  href="https://www.facebook.com/LIONMOTOS"
                  target="_blank"
                  @click="closeAppMenu"
                >
                  <ion-icon
                    icon="logo-facebook"
                    size="large"
                    color="medium"
                  ></ion-icon>
                </a>
              </ion-col>
              <ion-col>
                <a
                  href="https://www.instagram.com/lion_hol"
                  target="_blank"
                  @click="closeAppMenu"
                >
                  <ion-icon
                    icon="logo-instagram"
                    size="large"
                    color="medium"
                  ></ion-icon>
                </a>
              </ion-col>
              <ion-col>
                <a
                  href="https://wa.me/573213813097?text="
                  target="_blank"
                  @click="closeAppMenu"
                >
                  <ion-icon
                    icon="logo-whatsapp"
                    size="large"
                    color="medium"
                  ></ion-icon>
                </a>
              </ion-col>
              <ion-col>
                <a href="mailto:comercial1@lion.com.co" @click="closeAppMenu">
                  <ion-icon icon="mail" size="large" color="medium"></ion-icon>
                </a>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
      </ion-header>
      <ion-content>
        <ion-list class="app-menu-list">
          <ion-item @click="$router.push({ name: 'home' })">
            <i class="mdi mdi-store mdi-36px" slot="start"></i>
            <ion-label>Inicio</ion-label>
          </ion-item>
          <ion-item @click="$emitter.emit('open-fpl'), this.closeAppMenu()">
            <i
              class="mdi mdi-36px"
              :class="
                !loadProductMenu ? 'mdi-shopping' : 'mdi-timer-sand  mdi-spin'
              "
              slot="start"
            ></i>
            <ion-label>Productos</ion-label>
          </ion-item>
          <ion-item @click="$router.push({ name: 'about' })">
            <i class="mdi mdi-motorbike mdi-36px" slot="start"></i>
            <ion-label>Nosotros</ion-label>
          </ion-item>
          <ion-item
            @click="
              $router.push({ name: 'messageme' }),
                this.$store.dispatch('app/keepPageState', true),
                closeAppMenu()
            "
          >
            <i class="mdi mdi-message-draw mdi-36px" slot="start"></i>
            <ion-label>Contactenos</ion-label>
          </ion-item>
          <ion-item @click="$router.push({ name: 'contact' })">
            <i class="mdi mdi-map-marker-path mdi-36px" slot="start"></i>
            <ion-label>Donde Estamos</ion-label>
          </ion-item>
          <ion-item @click="$router.push({ name: 'cart' })">
            <div slot="start">
              <i class="mdi mdi-cart mdi-36px"></i>
              <i
                v-show="$store.state.cart.items.length > 0"
                class="mdi mdi-checkbox-multiple-marked-circle mdi-18px cart-indicator-menu"
              ></i>
            </div>
            <ion-label>Carro de compras</ion-label>
          </ion-item>
        </ion-list>
      </ion-content>
    </ion-menu>
    <header-app v-if="!$router.currentRoute.value.meta.hideAppBar" />
    <ion-router-outlet id="mainApp" class="main-router-view" />
  </ion-page>
</template>

<script>
import { IonRouterOutlet, menuController } from '@ionic/vue'
import headerApp from '../components/layout/header'

export default {
  name: 'App',
  data(vm) {
    return {
      loadProductMenu: false
    }
  },
  components: {
    IonRouterOutlet,
    headerApp
  },
  directives: {
    'my-on': {
      bind(el, binding) {
        let type = binding.arg
        let myFunction = binding.value
        el.addEventListener(type, myFunction)
      }
    }
  },
  created() {},
  beforeUnmount() {},
  watch: {
    $route(to, from) {
      menuController.isOpen('appMenu').then((res) => {
        if (res) {
          this.closeAppMenu()
        }
      })
    }
  },
  mounted() {},
  methods: {
    closeAppMenu() {
      menuController.close('appMenu')
    }
  }
}
</script>
<style>
.ios .cart-indicator-menu {
  position: absolute;
  top: 0.1rem;
  left: 2.5rem;
  opacity: 0.9;
  color: greenyellow;
}
.md .cart-indicator-menu {
  position: absolute;
  top: 0.2rem;
  left: 2.2rem;
  opacity: 0.9;
  color: greenyellow;
}

.main-router-view {
  /* margin-top: 50px; */
}
.app-menu-list ion-item {
  --background: #000000;
  --border-color: transparent;
}
.menu-app ion-header {
  --border-color: transparent;
}
.menu-app ion-list {
  padding-top: 0px;
  padding-bottom: 0px;
}
.menu-app ion-toolbar {
  --border-style: none;
}
.menu-app ion-thumbnail {
  --size: 150px;
}
</style>

<style lang="scss">
.center {
  display: grid;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-items: center;
}

.menu-app-header-separator {
  width: 100%;
  h2 {
    margin-top: 10px;
    font-size: 1.2rem;
    font-weight: bold;
    text-align: center;
    color: #fff;
  }
}
</style>
